module.exports = "images/doc-cotation-add-1.47462a2c89c5a442f9c0c6de993c17d1.png";